import React from 'react';
import VirgyMascot from './VirgyMascot';

/**
 * Wordmark used in the sidebar / login. Mascot + corporate name.
 *
 * The component is still exported as "VirgyWordmark" for backwards-compat
 * with existing imports; the rendered text is the customer-facing brand.
 */
export function VirgyWordmark({ className = '', size = 28 }) {
  return (
    <span className={`inline-flex items-baseline gap-2 ${className}`}>
      <VirgyMascot size={size} />
      <span className="font-display text-[1.05rem] leading-none" style={{ fontWeight: 600 }}>
        LampTwist <span className="text-[hsl(var(--text-muted))] font-medium">HR</span>
      </span>
    </span>
  );
}

export default VirgyWordmark;
